<template>
  <div class="Product">
    <div class="content">
      <img :src="ImageUrl" class="img-fluid" alt="Responsive image">
      <div class="content-detail">
        <h1 data-delighter class="left">印点点共享打印系统</h1>
        <p data-delighter class="right" style="margin-top:50px">30000+ 打印网点在使用</p>
        <p data-delighter class="right">极致便捷与成本控制，30s让打印机变成共享打印机</p>
      </div>
    </div>

    <div style="background-color: #F1F9FF;">
      <div class="container">
        <div class="row" style="text-align: center;">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="card-deck card-list">
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-item">
                <h2>微信扫码打印</h2>
                <p class="secd">用户使用微信、扫描二维码，控制打印机直接打印</p>
                <div style="margin-top: 20px;">
                  <p style="color: #0073CA;font-size: 24px;font-weight: 500;">特点：</p>
                  <p class="secd">不占用电脑、优化成本高峰分流、提高营收操作简便、吸引客户</p>
                </div>
                <div style="margin-top: 20px;">
                  <p style="color: #0073CA;font-size: 24px;font-weight: 500;">流程：</p>
                  <p class="secd" style="margin: 4px 0;">1、扫码发送文件</p>
                  <p class="secd" style="margin: 4px 0;">2、自动计价，微信支付</p>
                  <p class="secd" style="margin: 4px 0;">3、打印完成，领取文件</p>
                </div>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-icon">
                <img src="../assets/SharePrinting/advert_1.png" alt="Card image cap">
                <div>
                <el-button  round plain type="primary" style="transform: translateY(40px) translateX(20px);" @click="openVideo(require('../assets/SelfPrinting/微信扫码打印.mp4'))">观看视频</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-wrap">
      <div class="container" style="padding: 100px 0; text-align: center;">
        <h2 style="margin-bottom: 80px;">印点点共享打印特点</h2>
        <div class="row icons-grid">
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <div class="icon-item-box">
              <img class="icon-img" src="../assets/SharePrinting/features_1.png" alt="稳定输出">
              <h5 style="margin: 20px 0;">无需电脑</h5>
              <p class="secd">方便快捷</p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <div class="icon-item-box">
              <img class="icon-img" src="../assets/SharePrinting/features_2.png" alt="持续收入">
              <h5 style="margin: 20px 0;">无需盒子</h5>
              <p class="secd">节约成本</p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <div class="icon-item-box">
              <img class="icon-img" src="../assets/SharePrinting/features_3.png" alt="预收款项">
              <h5 style="margin: 20px 0;">网络接入</h5>
              <p class="secd">有网络即可使用</p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <div class="icon-item-box">
              <img class="icon-img" src="../assets/SharePrinting/features_4.png" alt="运维省心">
              <h5 style="margin: 20px 0;">30s接入</h5>
              <p class="secd">节省时间</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-wrap" style="background-color: #F1F6FB;">
      <div class="container" style="padding: 100px 0;">
        <div style="text-align:center;">
          <h2 style="margin-bottom: 70px;">应用场景解决方案</h2>
        </div>
        <div class="row" style="align-items: center;">
          <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 list-item">
            <div class="trigger" :class="{'active': activeIndex === 0}" @click="activeIndex=0" style="margin-bottom: 26px;width: 90%;">
              <h4 @click="activeIndex=0">个体小店，家有空闲设备</h4>
              <div style="margin: 20px 0;">
                <span class="secd" style="margin-bottom: 4px;font-weight: 700;color: #333;margin-right: 16px;">增收</span>
                <span class="secd">闲置设备，发挥余热</span>
              </div>
              <div class="line" style="height:1px;margin:14px 0 0;width: 100%;"></div>
            </div>
            <div class="trigger" :class="{'active': activeIndex === 1}" @click="activeIndex=1" style="margin-bottom: 26px;width: 90%;">
              <h4>快递驿站，增加便民服务</h4>
              <div style="margin: 20px 0;">
                <span class="secd" style="margin-bottom: 4px;font-weight: 700;color: #333;margin-right: 16px;">增收引流</span>
                <span class="secd">网点客户，二次转化；拓展业务，增加流量 </span>
              </div>
              <div class="line" style="height:1px;margin:14px 0 0;width: 100%;"></div>
            </div>
            <div class="trigger" :class="{'active': activeIndex === 2}" @click="activeIndex=2" style="width: 90%;">
              <h4>连锁酒店，提升客户体验</h4>
              <div style="margin: 20px 0;">
                <span class="secd" style="margin-bottom: 4px;font-weight: 700;color: #333;margin-right: 16px;">体验</span>
                <span class="secd">一站式服务，新面貌新体验 </span>
              </div>
              <div class="line" style="height:1px;margin:14px 0 0;width: 100%;"></div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-8 col-lg-8 list-icon" style="text-align:center;">
            <img v-if="activeIndex === 0" src="../assets/SharePrinting/advert_2.png" alt="/" style="max-width:100%;height:auto;">
            <img v-if="activeIndex === 1" src="../assets/SharePrinting/advert_2_2.png" alt="/" style="max-width:100%;height:auto;">
            <img v-if="activeIndex === 2" src="../assets/SharePrinting/advert_2_3.png" alt="/" style="max-width:100%;height:auto;">
          </div>
        </div>
      </div>
    </div>

    <div class="container" style="text-align: center;padding: 100px 0;">
        <h2 style="margin-bottom: 24px;">资金清算安全</h2>
        <p style="margin: 4px 0;color: #555;">商家可在后台开通微信商户，独立收款，交易资金不经过平台，</p>
        <p style="margin: 4px 0;color: #555;">由腾讯正规支付机构清算到商家银行卡，保障资金的合法合规。</p>
    </div>


    <div style="text-align: center;padding: 100px 0;background-color: #F1F9FF;">
      <div class="container">
        <h2 style="margin-bottom: 30px;">多版本 任您选择</h2>
        <p class="secd" style="margin: 4px 0;">考虑广大打印店主、投放商、运营商不同人群不同场景需要，</p>
        <p class="secd" style="margin: 4px 0;">我们推出三种方案可供选择，真正做到量身定制，契合匹配。</p>
      </div>
      <div class="container" style="margin-top: 80px;">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="card-deck">
              <div class="card card-kind ">
                <h4 class="version-tit">门店版<span class="secd" style="font-size: 16px;">（免费）</span></h4>
                <div class="card-body">
                  <img class="version-img" src="../assets/SharePrinting/version_1.png" alt="Card image cap">
                  <p class="card-title tit-h">试用共享打印软件</p>
                  <p class="card-text secd">（无需盒子）</p>
                </div>
              </div>
              <div class="card card-kind">
                <h4 class="version-tit">投放商版<span class="secd" style="font-size: 16px;">（付费）</span></h4>
                <div class="card-body">
                  <img class="version-img" src="../assets/SharePrinting/version_2.png" alt="Card image cap">
                  <p class="card-title tit-h">可增加网点·看好共享经济·适合投放</p>
                  <p class="card-text secd">（无需盒子，批量采购享受优惠）</p>
                </div>
              </div>
              <div class="card card-kind">
                <h4 class="version-tit">运营商版<span class="secd" style="font-size: 16px;">（付费）</span></h4>
                <div class="card-body">
                  <img class="version-img" src="../assets/SharePrinting/version_3.png" alt="Card image cap">
                  <p class="card-title tit-h">网点无限开通·适合投放+区域独家运营</p>
                  <p class="card-text secd">（无需盒子，区域运营商享受折上折）</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="margin: 20px 0;">
      <div v-for="(item, index) in dataList" :key="'dataList' + index">
        <div style="background-color: #F1F9FF;">
          <div class="container" style="text-align: center;padding: 37px 0;">
            <div class="row">
              <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" style="text-align: right;font-size: 24px;">
                {{ item.name }}
              </div>
              <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" style="font-size: 24px;">
                门店版
              </div>
              <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" style="font-size: 24px;">
                投放商版
              </div>
              <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" style="font-size: 24px;">
                运营商版
              </div>
            </div>
          </div>
        </div>
        <div class="container" style="text-align: center;">
          <div class="row" v-for="(items, index) in item.list" :key="items.label + index" style="line-height: 42px;border-bottom: 1px solid #F5F6F8;">
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" style="text-align: right;">
              {{ items.label }}
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <img v-if="items.v1 === true" src="../assets/SharePrinting/yes.png">
              <img v-else-if="items.v1 === false" src="../assets/SharePrinting/no.png">
              <span v-else>{{ items.v1 }}</span>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <img v-if="items.v2 === true" src="../assets/SharePrinting/yes.png">
              <img v-else-if="items.v2 === false" src="../assets/SharePrinting/no.png">
              <span v-else>{{ items.v2 }}</span>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <img v-if="items.v3 === true" src="../assets/SharePrinting/yes.png">
              <img v-else-if="items.v3 === false" src="../assets/SharePrinting/no.png">
              <span v-else>{{ items.v3 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="background-color: #F1F9FF;">
      <div class="container" style="text-align: center;padding: 100px 0;">
        <h2 style="margin-bottom: 10px;">现在开始，体验3.0版本的共享打印系统</h2>
        <div style="margin-top: 60px;display: flex;gap: 70px;justify-content: center;">
          <el-popover placement="top"  trigger="hover" width="280">
            <div style="display: flex;align-items: center;justify-content: center;gap: 60px;height: 240px;">
              <div style="display: flex;flex-direction: column;align-items: center;">
                <img class="noComputer" src="../assets/SharePrinting/noComputer.png" alt="/" style="width: 68px;height: 68px;">
                <div>无需电脑</div>
              </div>
              <div>
                <img class="noBox" src="../assets/SharePrinting/noBox.png" alt="/"  style="width: 68px;height: 68px;transform: translateX(-6px);">
                <div>无需盒子</div>
              </div>
            </div>
            <el-button slot="reference"  round plain type="primary">软件下载</el-button>
          </el-popover>

          <el-popover placement="top"  trigger="hover" width="280">
            <div style="display: flex;align-items: center;justify-content: center;height: 240px;flex-direction:column;">
              <div style="font-size: 16px;font-weight: 700;">印点点共享打印商户</div>
              <img class="noBox" src="../assets/SharePrinting/qrcode.png" alt="/"  style="width:180px;height: 180px;margin: 10px 0 6px;">
              <div style="color: #777;">请确保打印机和手机 WiFi处于同一网络</div>
            </div>
            <el-button slot="reference" round type="primary">开通试用</el-button>
          </el-popover>
          
        </div>
        <!-- <p class="secd" >扫码注册</p>
        <div>
          <img class="qrcode" src="../assets/SharePrinting/qrcode.png" alt="/">
        </div> -->
      </div>
    </div>
    <VideoModal ref="videoModal" />
  </div>
</template>
<script>
import VideoModal from './comm/VideoModal.vue'
export default {
  components: { VideoModal },
  data() {
    return {
      ImageUrl: require('../assets/SharePrinting/banner.png'),
      activeIndex: 0,
      dataList: [
        {
          name: "版本功能比较", list: [
            { label: "微信小程序自助打印", v1: true, v2: true, v3: true },
            { label: "QQ小程序自助打印", v1: true, v2: true, v3: true },
            { label: "自动计价", v1: true, v2: true, v3: true },
            { label: "营销活动", v1: true, v2: true, v3: true },
            { label: "会员充值", v1: true, v2: true, v3: true },
            { label: "文档打印", v1: true, v2: true, v3: true },
            { label: "照片打印", v1: true, v2: true, v3: true },
            { label: "证件照制作", v1: true, v2: true, v3: true },
            { label: "文件复印", v1: true, v2: true, v3: true },
            { label: "电子发票打印", v1: true, v2: true, v3: true },
            { label: "分账管理", v1: true, v2: true, v3: true },
            { label: "多门店管理", v1: false, v2: true, v3: true },
          ]
        },
        {
          name: "服务内容", list: [
            { label: "提供教程文档", v1: true, v2: true, v3: true },
            { label: "bug反馈及响应", v1: true, v2: true, v3: true },
          ]
        },
        {
          name: "运营扶持", list: [
            { label: "二级子账户", v1: false, v2: false, v3: true },
            { label: "推广商", v1: false, v2: false, v3: true },
            { label: "区域运营商", v1: false, v2: false, v3: true },
          ]
        },
      ],
    }
  },
  created() {
    window.scrollTo(0, 0);
  },
  mounted() {
  },
  methods: {
    openVideo(src) {
      if (this.$refs.videoModal && this.$refs.videoModal.open) {
        this.$refs.videoModal.open(src)
      }
    },
    downloadFn() {
      this.$message({
        message: "无需下载安装软件，可直接点击试用扫码体验哟！！",
        type: "success"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  position: relative;
  background: no-repeat center center;
  background-size: cover;
}

.secd {
  color: #666666;
}

.card-list {
  padding: 200px 0 158px;
}

.card-kind {
  border: 0px;
  background-color: inherit;

  .version-tit {
    padding-bottom: 50px;
    position: relative;

    &::after {
      content: "";
      width: 64px;
      height: 3px;
      background-color: #00cd95;
      position: absolute;
      border-radius: 99px;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .card-body {
    background-color: #fff;
    padding: 50px 0;
    transition: all 0.2s;

    &:hover {
      transform: scale(1.1, 1.1);
    }

    .version-img {
      width: 120px;
      height: 120px;
      box-shadow: 8px 14px 25px 1px rgba(0, 255, 185, 0.2);
      margin-bottom: 20px;
    }

    .tit-h {
      color: #00cd95;
      font-weight: 500;
    }
  }

  &:nth-child(2) {
    .version-tit::after {
      background-color: #ff725e;
    }

    .tit-h {
      color: #ff725e;
    }

    .version-img {
      box-shadow: 8px 14px 25px 1px rgba(255, 114, 94, 0.2);
    }
  }

  &:nth-child(3) {
    .version-tit::after {
      background-color: #00cbf1;
    }

    .tit-h {
      color: #00cbf1;
    }

    .version-img {
      box-shadow: 8px 14px 25px 1px rgba(0, 203, 241, 0.2);
    }
  }
}

.list-icon {
  display: flex;
  justify-content: center;
  position: relative;
  flex-direction: column;
}

.list-item {
  text-align: left;

  h2 {
    font-size: 40px;
    line-height: 28px;
    color: #18182a;
    margin-bottom: 24px;
  }

  p {
    font-size: 16px;
    line-height: 28px;
    color: #555;
  }
}

.content-detail {
  position: absolute;
  top: 8rem;
  left: 15vw;

  h1 {
    font-size: 2.8rem;
    line-height: 2rem;
    color: #fff;
  }

  p {
    font-size: 1.75rem;
    color: #fff;
  }
}

.trigger {
  cursor: pointer;
  .line {
    background: #dfe7f0;
  }
  &.active {
    h4,
    .label {
      color: #1b8af9;
    }
    .line {
      background: #1b8af9;
    }
  }
  &:hover {
    h4,
    .label {
      color: #1b8af9;
    }
    .line {
      background: #1b8af9;
    }
  }
}
.qrcode {
  width: 200px;
  height: 200px;
  border: 10px solid rgba(0, 146, 243, 0.1);
  border-radius: 10px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/SharePrinting.vue